module.exports = (__parcel__import__("fKeAS")).then(() => parcelRequire('fyWP3'));